import React from 'react'
import Header from './inc/Header';
import Footer from './inc/Footer';
import { auth } from '../helper/Utility';
import { Navigate, useLocation } from 'react-router-dom';
export const FrontLayout = ({ cmp, isHeader, isFooter, isProtected, mainFooter }) => {
    const authData = auth("user")
    const Component = cmp;
    const pathname = useLocation()?.pathname
    const onlyForEmployer = [
        '/payment-methods',
        '/subscription-plan',
        "/create-job",
        "/current-plan"
    ]

    if (isProtected && !authData) {
        return <Navigate to="/" replace />;
    }
    if (
        authData &&
        onlyForEmployer.includes(pathname) &&
        authData.user_role !== "employer"
    ) {
        return <Navigate to="/not-found" replace />;
    }
    return (
        <>
            {isHeader && <Header />}
            <Component />
            {isFooter && <Footer mainFooter={mainFooter} />}
        </>
    )
}
